import React, { Suspense, useState, useEffect, useRef } from "react";
import WizardServices from "./WizardServices";
import ContactSummary from "./contactSummary";
import cachingMechanisum from "../Common/cachingMechanisum";

export default function ContactWizardInfo(MainWizard: any) {

    const [save, setsave] = useState(false);
    const [unfield, setunfield] = useState(false);
    const formValidation = useRef<HTMLDivElement>(null);
    const [companySearch, setCompanySearch] = useState("");
    const [contactInfo, initContactInfo] = useState<any>([]);
    const [imprintList, initimprintListt] = useState<any>([]);
    const [CompanySelect, setCompanySelect] = useState(false);
    const [PayementValid, setPayementValid] = useState(false);
    const [selectedFile, setSelectedFile] = useState<any>(null);
    const [Classification, initClassification] = useState<any>([]);
    const [listCompanyInfos, initlistCompanyInfo] = useState<any>([]);
    const [SubClassification, initSubClassification] = useState<any>([]);
    const [classificationSearch, setclassificationSearch] = useState("");
    const [AllClassification, initAllClassification] = useState<any>([]);
    const [AllSubClassification, initAllSubClassification] = useState<any>([]);
    const [SubclassificationSearch, setSubclassificationSearch] = useState("");
    const [listCompanyInfostotalRows, setlistCompanyInfototalRows] = useState(0);

    useEffect(() => {
        console.log(MainWizard.data.code)

        if (MainWizard.data.code) {
            WizardServices.contactInfo(MainWizard.data.code).then((res) => {
                initContactInfo(res)

                if (res.creatorImage) {
                    setSelectedFile(res.creatorImage)
                }
            })

            WizardServices.contactTag({ area: "ContactType", referenceCode: MainWizard.data.code }).then((res) => {
                initSubClassification(res)
            })

            WizardServices.contactClassification({ CategoryType: "Creators", code: MainWizard.data.code }).then((res) => {
                initClassification(res)
            })
        }

        var imprintList = cachingMechanisum.getCachingStorage("labelList");
        initimprintListt(imprintList)
    }, []);

    const getAllSubClassification = () => {
        console.log(SubclassificationSearch)
        WizardServices.contactTag({ area: "ContactType", text: SubclassificationSearch, pageNumber: 1, pageSize: 10 }).then((res) => {
            initAllSubClassification(res)
        })
    }

    const getAllClassification = () => {
        console.log(classificationSearch)
        WizardServices.zFreeTextList({ formArea: "Creators", useFreeText: classificationSearch, pageNumber: 1, pageSize: 10 }).then((res) => {
            initAllClassification(res)
        })
    }

    const ClassificationSave = () => {
        WizardServices.zFreeTextSave({ formArea: "Creators", useFreeText: classificationSearch })
    }

    const ClassificationLinkSave = (data: any) => {
        WizardServices.zFreeTextSave({ formArea: "Creators", useFreeText: data.useFreeText, Code: MainWizard.data.code })
    }

    const subClassificationSave = () => {
        WizardServices.contactTagSave({ area: "ContactType", isActive: 1, isCustom: 1, code: classificationSearch, text: classificationSearch })
    }

    const subClassificationLinkSave = (data: any) => {
        WizardServices.contactTagSave({ area: "ContactType", isActive: data.isActive, isCustom: data.isCustom, referenceCode: MainWizard.data.code, code: data.code, text: data.text })
    }

    const listCompanyInfo = () => {
        WizardServices.listCompanyInfo({ kontactCode: "", companyName: companySearch.length > 0 ? companySearch : "", pageNumber: 1, pageSize: 10 }).then((res) => {
            initlistCompanyInfo(res)
            setlistCompanyInfototalRows(res && res[0] && res[0].totalRows ? res[0].totalRows : 0)
        })
    }

    const handleFieldChange = (e: any) => {

        var Field_name = e.target.name;
        var Field_value = e.target.value;
        var Field_type = e.target.type;

        console.log(Field_value)
        console.log(Field_type)
        if (Field_type === "checkbox") {
            Field_value = !Field_value;
        }
        const containsPeriod = Field_name.includes('.');

        let updatedObject = { ...contactInfo };

        if (containsPeriod) {
            const parts = Field_name.split('.');

            let currentLevel = updatedObject;
            for (let i = 0; i < parts.length; i++) {
                if (i < parts.length - 1) {
                    if (!currentLevel[parts[i]]) {
                        currentLevel[parts[i]] = {};
                    }
                    currentLevel = currentLevel[parts[i]];
                } else {
                    currentLevel[parts[i]] = Field_value;
                }
            }
        } else {
            updatedObject[Field_name] = Field_value;
        }

        console.log(updatedObject);
        initContactInfo(updatedObject);


    };

    useEffect(() => {
        handleKontactCode(contactInfo)
    }, [contactInfo.firstName]);

    useEffect(() => {
        handleKontactCode(contactInfo)
    }, [contactInfo.lastName]);

    const handleKontactCode = (e: any) => {

        if (!contactInfo.firstName) {
            contactInfo.firstName = ''
        }

        if (!contactInfo.lastName) {
            contactInfo.lastName = ''
        }

        initContactInfo((existingValues: any) => ({
            ...existingValues, kontactName: contactInfo.firstName + " " + contactInfo.lastName
        }))
    }

    const saveCreator = () => {
        var validSave = handleFieldRequired(contactInfo);
        if (validSave) {
            WizardServices.kontactSave(contactInfo, selectedFile).then((res) => {
                initContactInfo(res)
                MainWizard.onSave(res)
                setsave(true);
                const inputs: any = formValidation.current?.querySelectorAll('input');
                Object.values(inputs).map((values: any) => {
                    var fieldName: any = document.getElementById(values.id);
                    fieldName.style.border = "solid #DEDEDE 1px";

                })
            });
        } else {
            setunfield(true)
        }
        setTimeout(function () {
            setsave(false);
            setunfield(false);
        }, 3000);
    }

    const handleFieldRequired = (object: any) => {
        const inputs: any = formValidation.current?.querySelectorAll('input');
        var valid = true;

        Object.values(inputs).map((values: any) => {
            const isRequired = document.getElementById(values.id)?.hasAttribute('required');

            if (isRequired) {
                if (!object[values.id]) {
                    var fieldName: any = document.getElementById(values.id);
                    fieldName.style.border = "1px solid #ff0000";
                    valid = false;
                }
            }

        })

        return valid;
    }

    const clearSForm = () => {
        initContactInfo([])
    }

    const UploadImage = (e: any) => {

        const file = e.target.files && e.target.files[0];
        if (e.target.files) {
            //console.log(file)
            setSelectedFile(file);
        }
    }

    return (<>
        <div className="ws-12">
            <div className="box-header"> <h1>Contact Creation Wizard</h1> </div>

            <div className="box-content">

                <div className="ws-8" ref={formValidation}>

                    {unfield && <div className="alert alert-danger">
                        There was a problem submitting your request, one or more fields are missing or incorrect.
                    </div>}

                    {save && <div className="alert alert-success"> Contact has been saved successfully. You may now add personal information. </div>}

                    <div className="w-42">
                        <div className="form-format">
                            <label className="control-label"> First Name* </label>

                            <div className="label-entries">
                                <input type="text" id="firstName" name="firstName" value={contactInfo.firstName ? contactInfo.firstName : ""}
                                    onChange={(e) => { handleFieldChange(e) }} placeholder="Enter first name" required />
                            </div>
                        </div>
                    </div>

                    <div className="w-43">
                        <div className="form-format">
                            <label className="control-label">Last Name</label>

                            <div className="label-entries">
                                <input type="text" id="lastName" value={contactInfo.lastName ? contactInfo.lastName : ""} name="lastName"
                                    onChange={(e) => { handleFieldChange(e); }} placeholder="Last Name" />
                            </div>
                        </div>

                        <div className="form-format hide" >
                            <label className="control-label"> Display name  </label>

                            <div className="label-entries">
                                <input type="text" id="kontactDisplay" value={contactInfo.kontactDisplay ? contactInfo.kontactDisplay : ""} placeholder="Display name" />
                            </div>
                        </div>
                    </div>

                    <div className="form-format w-90">
                        <label className="control-label"> Email Address </label>

                        <div className="label-entries">
                            <input type="email" id="emailAdd1" value={contactInfo.emailAdd1 ? contactInfo.emailAdd1 : ""} name="emailAdd1"
                                onChange={(e) => handleFieldChange(e)} placeholder="Enter email address" />
                        </div>
                    </div>

                    <div className="form-format w-90">
                        <label className="control-label"> Contact Code* </label>

                        <div className="label-entries">
                            <input type="text" id="kontactCode" value={contactInfo.kontactCode ? contactInfo.kontactCode : ""} disabled={true} name="kontactCode"
                                placeholder="Enter contact code" />
                        </div>
                    </div>

                    <div className="form-format w-90">
                        <label className="control-label"> Contact Name* </label>

                        <div className="label-entries">
                            <input type="text" id="kontactName" value={contactInfo.kontactName ? contactInfo.kontactName : ""} disabled={true} name="kontactName"
                                placeholder="Enter contact name" required />
                        </div>
                    </div>

                    <div className="form-format w-90">
                        <label className="control-label">Imprint</label>
                        <div className="label-entries w-90">
                            <select id="mainImprint" name="mainImprint" onChange={(e) => handleFieldChange(e)} value={contactInfo.mainImprint ? contactInfo.mainImprint : ""} >
                                <option value="" > Choose an Imprint</option>

                                {
                                    imprintList?.map((values: any) => {
                                        return (
                                            <option value={values.companyName} label={values.companyName}>{values.companyName}</option>
                                        )
                                    })
                                }

                            </select>

                        </div>
                    </div>

                    <div className="w-90">
                        <div className="form-format ws-12">
                            <label className="control-label"> Company Name </label>

                            <div className="label-entries">
                                <div className="w-90">
                                    <input type="text" id="companyName" value={contactInfo.companyName ? contactInfo.companyName : ""} name="companyName" placeholder="Enter Company Name" />
                                </div>
                                <div className="w-5">
                                    <button className="icon-btn primary" type="button" onClick={() => { setCompanySelect(true); listCompanyInfo(); }}><i className="icon-add-solid"></i></button>
                                </div>
                            </div>

                        </div>
                        {CompanySelect && <div className="positionAbsolute pLarge" >
                            <div className="box landing borderSolid ws-12 mrl mtll" >
                                <div className="ws-12 pLarge">
                                    <div className="modal-header">
                                        <button type="button" className="btn btn-xs pull-right mbl" onClick={() => setCompanySelect(false)}><i className="icon-arrow-left m0 p0"></i></button>
                                    </div>
                                    <div className="box ws-12 mt" ng-show="companyListDetails !== null">
                                        <div className="box-header well"> <h2><i className="icon-info"></i>Company Details</h2> </div>
                                        <div className="box-header well">
                                            <h2><i className="fa fa-table"></i> <span>{listCompanyInfostotalRows} record(s) found</span>
                                            </h2>
                                        </div>

                                        <div className="box-content">
                                            <div className="form-format ws-6 mb" style={{ marginLeft: "25%" }}>
                                                <div className="label-entries">
                                                    <div className="ws-8">
                                                        <input type="text" placeholder="Enter Company Name" value={companySearch} onChange={(e) => setCompanySearch(e.target.value)} id="companyName" />
                                                    </div>
                                                    <div className="ws-2">
                                                        <button type="button" onClick={() => { listCompanyInfo(); }} className="icon-btn edit" > <i className="icon-search"></i></button>
                                                    </div>
                                                </div>
                                            </div>
                                            {(listCompanyInfostotalRows === 0) && <div className="alert alert-info">No records to display</div>}
                                            {(listCompanyInfostotalRows > 0) && <div className="table-responsive">
                                                <table className="newTable">
                                                    <thead>
                                                        <tr>
                                                            <th >Company code</th>
                                                            <th >Company name</th>
                                                            <th >Operation</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {listCompanyInfos?.map((values: any) => {

                                                            return (
                                                                <tr >
                                                                    <td >{values.companyKontactCode} </td>
                                                                    <td >{values.companyName} </td>
                                                                    <td >
                                                                        <a onClick={() => { contactInfo.companyName = values.companyName; setCompanySelect(false); }} className="icon-btn info">
                                                                            <i className="icon-th icon-white"></i>Select
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })}

                                                    </tbody>
                                                </table>
                                            </div>}


                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>}
                    </div>

                    <div className="form-format w-90">
                        <label className="control-label">Min Payment</label>

                        <div className="label-entries">
                            <input type="number" min="0" id="minPayment" name="minPayment" value={contactInfo.minPayment ? contactInfo.minPayment : 0}
                                onChange={(e) => handleFieldChange(e)} placeholder="Min Payment" />
                            {PayementValid && <div className="alert alert-danger">  Min Payment should be numeric and greater than 0. </div>}
                        </div>
                    </div>

                    <div className="ws-5 mtl ">
                        <div className="form-format">
                            <label className="control-label ws-5">Crossed Pay</label>
                            <div className="label-entries ws-1">
                                <label className="switch">
                                    <input type="checkbox" checked={contactInfo.crossedPay} value={contactInfo.crossedPay ? contactInfo.crossedPay : ""} name="crossedPay" />
                                    {contactInfo.crossedPay && <span className="slider round text-left white pm pts" >Yes</span>}
                                    {!contactInfo.crossedPay && <span className="slider round text-right white pm pts sliderOff">No</span>}
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="ws-6 mtl">
                        <div className="form-format">
                            <label className="control-label ws-6">Convert to Creator</label>
                            <div className="label-entries ws-1">
                                <label className="switch">
                                    <input type="checkbox" checked={contactInfo.creator} value={contactInfo.creator ? contactInfo.creator : ""} name="creator" />
                                    {contactInfo.creator && <span className="slider round text-left white pm pts">Yes</span>}
                                    {!contactInfo.creator && <span className="slider round text-right white pm pts sliderOff">No</span>}

                                </label>
                            </div>

                        </div>

                    </div>

                    {contactInfo.creator && <div>

                        <div className="form-format ws-12">
                            <label className="control-label text-left" >Classification</label>
                            <div className="label-entries ws-12">
                                <div className="w-73">
                                    <input type="text" value={classificationSearch ? classificationSearch : ""} onChange={(e) => setclassificationSearch(e.target.value)}
                                        placeholder="Type to search for classification" />
                                </div>
                                <div >
                                    <button className="icon-btn edit pl pr pts" onClick={getAllClassification}>
                                        <i className="icon-search"></i>
                                    </button>
                                </div>
                                {classificationSearch.length > 0 && <div className="ws-2">
                                    <button className="icon-btn edit pl pr pts" onClick={() => ClassificationSave()}>
                                        <i className="icon-save"></i>
                                    </button>
                                </div>}
                            </div>

                            {AllClassification && AllClassification.length === 0 && classificationSearch.length > 0 && <div className="ml w-76"> <p>No result. Save it as a new classification.</p> </div>}

                            <table className="table ml w-76">
                                <tbody>
                                    {
                                        AllClassification.map((values: any) => {
                                            return (
                                                <tr>
                                                    <td width="20%"> <input type="checkbox" onClick={() => ClassificationLinkSave(values)} /></td>
                                                    <td><a>{values.useFreeText}</a></td>
                                                </tr>
                                            )
                                        })}

                                </tbody>
                            </table>

                            <div className="form-format ws-12 mtl">
                                <label className="control-label text-left w-35 mt">Associated Classification(s):</label>
                                <div className="label-entries ws-7">
                                    {!Classification && <div className="alert alert-info"> No classification available </div>}

                                    {Classification?.map((values: any) => {

                                        return (

                                            <a className="btn ms ps" style={{ background: "#EF534F ", color: "#fff" }}>
                                                <span className="mts mb text-center">{values.categoryName}</span>
                                                <span className="pull-right mtss">
                                                    <i className="icon-close1 text-s ms pls" data-ng-click="removeClassification(item)"></i>
                                                </span>
                                            </a>)
                                    })}

                                </div>
                            </div>
                        </div>

                        <div className="form-format ws-12">
                            <label className="control-label text-left">Sub Classification</label>
                            <div className="label-entries ws-12">
                                <div className="w-73">
                                    <input type="text" value={SubclassificationSearch ? SubclassificationSearch : ""} onChange={(e) => setSubclassificationSearch(e.target.value)}
                                        placeholder="Type to search for sub classification" />
                                </div>
                                <button className="icon-btn edit pl pr pts" onClick={getAllSubClassification}>
                                    <i className="icon-search"></i>
                                </button>

                                {SubclassificationSearch.length > 0 && <button className="icon-btn edit pl pr pts" onClick={() => subClassificationSave()}>
                                    <i className="icon-save"></i>
                                </button>}

                            </div>

                            {AllSubClassification && AllSubClassification.length === 0 && SubclassificationSearch.length > 0 && <div className="ml w-76"> <p>No result. Save it as a new sub-classification.</p> </div>}

                            <table className="table ml w-76">
                                <tbody>
                                    {AllSubClassification.map((values: any) => {
                                        return (
                                            <tr>
                                                <td width="20%"> <input type="checkbox" onClick={() => subClassificationLinkSave(values)} /></td>
                                                <td><a>{values.code}</a></td>
                                            </tr>
                                        )
                                    })}

                                </tbody>
                            </table>

                            <div className="form-format ws-12 mtl" >
                                <label className="control-label text-left w-35 mt">Associated Sub Classification(s):</label>
                                <div className="label-entries ws-7">
                                    {!SubClassification && <div className="alert alert-info"> No sub classification available </div>}

                                    {SubClassification?.map((values: any) => {
                                        return (
                                            <a className="btn ms ps" style={{ background: "#EF534F ", color: "#fff" }}>
                                                <span className="mts mb text-center">{values.code}</span>
                                                <span className="pull-right mtss">
                                                    <i className="icon-close1 text-s ms pls" data-ng-click="removeClassification(item)"></i>
                                                </span>
                                            </a>)
                                    })
                                    }

                                </div>
                            </div>

                        </div>

                    </div>}

                </div>

                <div className="ws-4 pm mb">

                    <div className="creatorImg pm pull-left">

                        <div className="box shadowCoverPicture shadow">

                            <div className="coverPicture">
                                <img className="ws-12" src={selectedFile} alt="Default Image" />
                            </div>
                            <div className="ws-12 pm">
                                <label className="control-label ws-12 text-bold text-uppercase" >
                                    {contactInfo.kontactName ? contactInfo.kontactName : ""}
                                </label>
                                <label className="control-label ws-12 text-bold text-uppercase ms" >
                                    {contactInfo.kontactCode ? contactInfo.kontactCode : ""}
                                </label>

                            </div>
                        </div>
                    </div>

                    <div className="ws-12 centerWindow pl">

                        <div className="ws-9 pm centerWindow">
                            <label className="icon-btn primary mll">Upload Image
                                <input type="file" accept="*" id="file-upload" onChange={(e) => UploadImage(e)} className="hide" />
                            </label>

                        </div>

                    </div>
                </div>

            </div>

            <div className="box-footer">
                <div className="pull-right">
                    <button className="icon-btn edit" onClick={(e) => { saveCreator(); }}> <i className="icon-save"></i> Save </button>
                    <button className="btn-pink" onClick={() => clearSForm()}>  <i className="icon-reload"></i> Reset </button>
                </div>

            </div>

        </div>
    </>
    )

}